/**
 * 访问日志表状态管理
 *
 * @author System
 * @since 2026-03-09
 */
const state = {
    columnInfo: {
        logType: {
            visible: true,
            label: "日志类型"
        },
        username: {
            visible: true,
            label: "用户名"
        },
        operation: {
            visible: true,
            label: "操作描述"
        },
        method: {
            visible: true,
            label: "请求方法"
        },
        requestUrl: {
            visible: true,
            label: "请求URL"
        },
        ip: {
            visible: true,
            label: "IP地址"
        },
        location: {
            visible: true,
            label: "IP归属地"
        },
        status: {
            visible: true,
            label: "状态"
        },
        executeTime: {
            visible: true,
            label: "执行时长"
        },
        createDate: {
            visible: true,
            label: "记录时间"
        }
    },
    tableData: [],
    totalCount: 0,
    statistics: {
        todayVisitCount: 0,
        todayLoginUserCount: 0,
        todaySuccessRate: '0%',
        todayAvgExecuteTime: '0ms'
    },
    options: {},
    queryParams: {
        currPage: 1,
        limit: 20,
        ascOrder: false,
        orderField: "",
        param: {
            logType: undefined,
            username: undefined,
            ip: undefined,
            requestUrl: undefined,
            status: undefined
        }
    },
    dateRange: {
        createDate: []
    },
    formInfo: {
        dialogVisible: false,
        isAdd: false,
        editData: {}
    },
    moreButtonProps: []
}
export default state
